<template>
<div class="chapter">
<div class="inner_page">
<p class="C52"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="C53"><a id="page_v"><em></em></a><em><a href="#/xhtml/04_Acknowledgments#page_vii">Acknowledgments</a></em></p>
<p class="C54"><a href="#/xhtml/05_Introduction#page_1">Introduction</a></p>
<p class="C54"><a href="#/xhtml/06_1__The_Political_Theology_of_Lat#page_11">1. The Political Theology of Late Capital</a></p>
<p class="C54"><span href="#/xhtml/07_2__The_Political_and_the_Economi#page_39" title="Link target outside of Sample">2. The Political and the Economic</span></p>
<p class="C54"><span href="#/xhtml/08_3__Neoliberalism_s_Demons#page_69" title="Link target outside of Sample">3. Neoliberalism’s Demons</span></p>
<p class="C54"><span href="#/xhtml/09_4__This_Present_Darkness#page_97" title="Link target outside of Sample">4. This Present Darkness</span></p>
<p class="C53"><span href="#/xhtml/10_Conclusion__After_Neoliberalism#page_127" title="Link target outside of Sample">Conclusion: After Neoliberalism</span></p>
<p class="C54"><em><span href="#/xhtml/11_Notes#page_145" title="Link target outside of Sample">Notes</span></em></p>
<p class="C54"><em><span href="#/xhtml/12_Bibliography#page_157" title="Link target outside of Sample">Bibliography</span></em></p>
<p class="C54"><em><span href="#/xhtml/13_Index#page_163" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?35758819